import { useDataValueOnce } from 'Logic/FlowShortcuts'

export default function useEnsureDefaultTab(props, data) {
  let patient_id = useDataValueOnce({
    context: 'flow_shortcuts',
    path: 'patientId',
    viewPath: props.viewPath,
  })
  let patientTab = useDataValueOnce({
    context: 'flow_shortcuts',
    path: 'patientTab',
    viewPath: props.viewPath,
  })

  return function ensureDefaultTab(maybeTab, id) {
    if (maybeTab?.selected) return maybeTab

    let tab = maybeTab?.tab || PATIENT_TABS[patientTab] || 'profile'

    return {
      ...data,
      id: id || patient_id,
      // TODO: move to selected
      patient_id: id || patient_id,
      tab,
      selected: {
        ...data.selected,
        ledger: {
          payor: maybeTab?.data?.selected_payor_id,
        },
      },
    }
  }
}

let PATIENT_TABS = {
  medical: 'medical',
  documents: 'documents',
  images: 'images',
  ledger: 'ledger',
  notes: 'notes',
  treatment: 'treatment_card',
  'dental-monitoring': 'dental-monitoring',
}
